import react, { useRef, useEffect, ReactElement } from "react";
import ReactDOM from "react-dom";
import GoogleMapReact from 'google-map-react';


const SpotMarker = ({ text, lat }) => {
  // console.log(lat)
  return (
    <div className="location-Marker" style={{display: lat ? 'block' : 'none'}}></div>
  )


}


const MapComponent = ({ lat, long }) => {
  const defaultProps = {
    center: {
      lat: 39.7348866,
      lng: -7.9616414
    },
    zoom: 6
  };

  const center = [lat,long]


  const night= [
    { elementType: "geometry", stylers: [{ color: "#242f3e" }] },
    { elementType: "labels.text.stroke", stylers: [{ color: "#242f3e" }] },
    { elementType: "labels.text.fill", stylers: [{ color: "#746855" }] },
    {
      featureType: "administrative.locality",
      elementType: "labels.text.fill",
      stylers: [{ color: "#d59563" }],
    },
    {
      featureType: "poi",
      elementType: "labels.text.fill",
      stylers: [{ color: "#d59563" }],
    },
    {
      featureType: "poi.park",
      elementType: "geometry",
      stylers: [{ color: "#263c3f" }],
    },
    {
      featureType: "poi.park",
      elementType: "labels.text.fill",
      stylers: [{ color: "#6b9a76" }],
    },
    {
      featureType: "road",
      elementType: "geometry",
      stylers: [{ color: "#38414e" }],
    },
    {
      featureType: "road",
      elementType: "geometry.stroke",
      stylers: [{ color: "#212a37" }],
    },
    {
      featureType: "road",
      elementType: "labels.text.fill",
      stylers: [{ color: "#9ca5b3" }],
    },
    {
      featureType: "road.highway",
      elementType: "geometry",
      stylers: [{ color: "#746855" }],
    },
    {
      featureType: "road.highway",
      elementType: "geometry.stroke",
      stylers: [{ color: "#1f2835" }],
    },
    {
      featureType: "road.highway",
      elementType: "labels.text.fill",
      stylers: [{ color: "#f3d19c" }],
    },
    {
      featureType: "transit",
      elementType: "geometry",
      stylers: [{ color: "#2f3948" }],
    },
    {
      featureType: "transit.station",
      elementType: "labels.text.fill",
      stylers: [{ color: "#d59563" }],
    },
    {
      featureType: "water",
      elementType: "geometry",
      stylers: [{ color: "#17263c" }],
    },
    {
      featureType: "water",
      elementType: "labels.text.fill",
      stylers: [{ color: "#515c6d" }],
    },
    {
      featureType: "water",
      elementType: "labels.text.stroke",
      stylers: [{ color: "#17263c" }],
    },
  ];
  //console.log(lat, long, center )
  return (
    // Important! Always set the container height explicitly
    <div className="GoogleMapReact" style={{ height: '70vh', width: '100%', borderRadius: '6px'}}>
      <GoogleMapReact
        bootstrapURLKeys={{ key: "AIzaSyDiQImz2VYZlRubgd2YBQAwCoEGTCipBkw" }}
        defaultCenter={defaultProps.center}
        defaultZoom={defaultProps.zoom}
        center={[lat,long]}
        zoom={18}
        options={{styles:night}}
        onGoogleApiLoaded={({ map, maps }) => console.log(map, maps)}
      >
        <SpotMarker
          lat={lat}
          lng={long}
          text="My Marker"
        />
      </GoogleMapReact>
    </div>
  ) ;
}

export default MapComponent